import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle = ({ title }) => {
    const location = useLocation();

    useEffect(() => {
        document.title = title + ' - ' + process.env.REACT_APP_FPSB_PORTAL_META_TITLE;
    }, [location, title]);

    return null;
};

export default PageTitle;